module.exports = __webpack_public_path__ + "static/img/meter.749180b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/meter.jpg
// module id = I1uG
// module chunks = 2